import React, { useState, useEffect, useContext } from "react";
import { Alert, Box, Grid, TextField, Typography, Button, Paper, Checkbox, FormControlLabel, Tooltip } from '@mui/material';
import { Radio, RadioGroup, FormControl, FormLabel } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Switch from '@mui/material/Switch';
import FormGroup from "@mui/material/FormGroup";
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import successIcon from '../assets/payment-success-icon.png';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { useMember } from '../context/MemberProfileContext';
import parse from 'html-react-parser';

import PaymentComp from '../components/PaymentComp'
import PaypalComp from '../components/PaypalComp';
import { DataContext } from '../App';


export default function CulturalRegistration() {
    
    const [tempData, setTempData] = useState({
        "membershipType": "",
        "membershipGeneralAdmissionFee": 0,
        "membershipParivarNoBalaviharFee": 0,
        "membershipParivarMemberFee": 0,
        "membershipSingleChildFee": 0,
        "membershipTwoPlusChildFee": 0,
        "membershipTypeName": "",
    });
    const { accessToken, signOut } = useAuth();
    const [eventTxnsHistory, setEventTxnsHistory] = useState();

    useEffect(() => {

        console.log("Token exists or not :", accessToken);
    
        if (accessToken) {
            console.log("Token exists or not test:", accessToken);       
            memberProfileFetch(); // Load membership data
            console.log("Temp data :", tempData);
            eventTxnsHistoryFetch();

        } else {
            signOut();
            navigate('/');
        }
      }, [accessToken])         // Empty dependency array ensures this runs once on mount;

            //Chinmaya Parivar Member
    const [payloadData, setPayloadData] = useState({});
    const [eventData, setEventData] = useState({
        "balaviharYear": "2025",
        "membershipType": {
            "name": ""
        },
        status: "",
        "notes": "first event1",       
        transaction: {
            quantities: 1,
            itemPrice: 0,
            totalAmount: "",
            donationAmount: "",
            payerId: "",
            notes: "Multiple Events"
        },
        medical: {
                },
        "events": [

        ],
        eventType: 'Language/Cultural Event',
        feeEnabled: 0,
        parent: {
            firstName: "",
            lastName: "",
            email: "",
            mobileNumber: ""              
            
    }});
    //to populate registered children
    const { memberProfile, setMemberProfile } = useMember();
    const { eventTypes, setEventTypes } = useMember ();
    
    //const [fullNames, setFullNames] = useState();
    const [fullNames, setFullNames] = useState(
        memberProfile.children.map((child) => ({
            fullName: child.fullName,
            memberId: child.memberId, // to keep track of memberId if needed
        }))
    );
    const [email, setEmail] = useState("");
    useEffect(() => {        
        setEmail(memberProfile.primary.email); // Assign email from memberProfile
    }, [])         // Empty dependency array ensures this runs once on mount
    useEffect(() => {
            eventData.parent.firstName = memberProfile.primary.firstName;
            eventData.parent.lastName = memberProfile.primary.lastName;
            eventData.parent.email = memberProfile.primary.email;
            eventData.parent.mobileNumber = memberProfile.primary.mobileNumber.replace(/[-\s]/g, ''); // Remove hyphens and spaces    
        }, [])         // Empty dependency array ensures this runs once on mount
    

    const [culturalEventTypes, setCulturalEventTypes] = useState([]);
    const [eventDescription, setEventDescription] = useState("");
    const [languageEventType, setLanguageEventType] = useState(0);

    useEffect(() => {
        console.log("Event Types in Cultural Registration:", eventTypes);
        if (eventTypes && eventTypes.length > 0) {
            // Find the eventTypeId of the record where name === 'Languages'
            setLanguageEventType(eventTypes.find((eventType) => eventType.name === 'Language/Cultural Event'));
            const parentLanguageEventType = eventTypes.find((eventType) => eventType.name === 'Language/Cultural Event');
            if (parentLanguageEventType) {
                const filteredEventTypes = eventTypes.filter(
                    (eventType) => eventType.parentEventTypeId === parentLanguageEventType.eventTypeId
                );
                setCulturalEventTypes(filteredEventTypes);
                console.log("Filtered Cultural Event Types:", filteredEventTypes);
            } else {
                console.log("No event type found with the name 'Languages'");
                setCulturalEventTypes([]); // Set to an empty array if no matching record is found
            }
        }
    }, [eventTypes]);

    const handleEventSelection = (e, child, eventType) => {
        const isChecked = e.target.checked;
      
        console.log("Full Name: ", child.fullName, child.memberId, eventType, eventType.eventTypeId, eventType.name, isChecked, eventTypes.eventTypeId);
      
        setEventData((prevEventData) => {
            const updatedEvents = [...prevEventData.events];
        
            if (isChecked) {
              // Add the event if the checkbox is checked
              updatedEvents.push({
                memberId: child.memberId,
                eventTypeId: eventType.eventTypeId,
              });
            } else {
              // Remove the event if the checkbox is unchecked
              const indexToRemove = updatedEvents.findIndex(
                (event) =>
                  event.memberId === child.memberId &&
                  event.eventTypeId === eventType.eventTypeId
              );
              if (indexToRemove !== -1) {
                updatedEvents.splice(indexToRemove, 1);
              }
            }
                
            return {
              ...prevEventData,
              events: updatedEvents,
            };
          });
      };
      // 
      const memberPrices = {}; // Object to store prices for each child
      const memberPaid = {}; // Object to store already paid amounts for each child

    // Function to handle radio selection for a member
    const handleEventRadioChange = (memberId, eventTypeId) => {
    setEventData((prev) => {
        const updatedEvents = [
        ...prev.events.filter(ev => ev.memberId !== memberId),
        { memberId, eventTypeId: parseInt(eventTypeId, 10) } // Ensure eventTypeId is an integer
        ];
        // After updating, calculate the new total
        console.log("Updated Events after radio change:", updatedEvents);
        setTotalAmount(calculateTotalPrice(updatedEvents));
        return { ...prev, events: updatedEvents };
    });
    };

    // Calculate total price based on selected events
    const calculateTotalPrice = (events = eventData.events) => {
    let total = 0;
    events.forEach((event) => {
        const eventType = culturalEventTypes.find(
        (type) => String(type.eventTypeId) === String(event.eventTypeId)
        );
        console.log("Event data in calculateTotalPrice :", eventData.events, event.memberId, eventType, culturalEventTypes);
        if (eventType && eventType.price) {
        total += parseInt(eventType.price, 10);
                        console.log("Event Type price:", eventType.price, "for Event:", event);

        }
        
    });
    console.log("Calculated total price:", total, "for events:", events);
    return total;
    };

    const [sessions, setSessions] = useState();
    const [studentFields, setStudentFields] = useState([]);
    const [error, setError] = useState(null);
    
    const [rulesAccepted, setRulesAccepted] = useState(false); // State to manage checkbox
    const API_URL = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
    const { memberships, setMemberships} = useMember();
    const [parivarMember, setParivarMember] = useState(false);
   
    
    const [ticketPrice, setTicketPrice] = useState(0);  
    console.log("Enter Cultural Registration: ", eventData, culturalEventTypes, eventTypes);



  useEffect(() => {
    console.log("inside membership changes :");

      if (memberships && memberships.membershipTypes && memberships.membershipTypes.length > 0) {
          loadMembershipFeeData(); // Load membership fee data
          setSessions(memberships.availableSessions.map((child) => child.sessionName));
              console.log("inside membership changes1 :");
     
      }  
     
    if (memberships.registeredSessions && memberships.registeredSessions.length > 0) {
        setStudentFields(memberships.registeredSessions.map((session) => ({
            memberType: "child",
            firstName: session.memberEntity.firstName,
            lastName: session.memberEntity.lastName,
            fullName: session.memberEntity.fullName,
            session: session.sessionEntity.sessionName,
            grade: session.gradeEntity.grade,
        })));
        setNoOfPeople(memberships.registeredSessions.length);
            console.log("inside membership changes2 :");

    }
    if ((memberships.status === "ACTIVE") && (memberships.currentMembership.membershipTypesEntity.name === "Chinmaya Parivar Member")) 
        {
        setParivarMember(true);
        };

  }, [memberships]);


    const [inputFields, setInputFields] = useState(eventData.transaction);
        const [feeEnabled, setFeeEnabled] = useState(0);
    const [parivarEnabled, setParivarEnabled] = useState(false);

    const [donation, setDonation] = useState(0);
    const [totalAmount, setTotalAmount] = useState(inputFields.quantities * inputFields.itemPrice);
    const [noOfPeople, setNoOfPeople] = useState(0);
 
    const total = () => {
        inputFields.donationAmount = donation;
        inputFields.totalAmount = totalAmount;
        eventData.transaction = inputFields;
    }
    total();
    
    useEffect(() => {

        setTicketPrice(calculateTotalPrice());
        //console.log("RUn 0 calculate price :", (eventData.events), ticketPrice, totalAmount);

        if (parivarEnabled || parivarMember) {
            setTicketPrice(tempData.membershipParivarMemberFee - memberships.totalAmountPaid);
            if (tempData.membershipType === "Balavihar" || memberships.status === "ACTIVE" ) {
                setTicketPrice(tempData.membershipParivarMemberFee - memberships.totalAmountPaid);
            }
            if (tempData.membershipType === "GeneralAdmission" || memberships.status === "ACTIVE" ) {
                setTicketPrice(tempData.membershipParivarNoBalaviharFee - memberships.totalAmountPaid);
            }
        }

        eventData.transaction.itemPrice = ticketPrice;

        if (feeEnabled) {
            setTotalAmount(((parseInt(ticketPrice) + parseInt(donation)) * 1.03).toFixed(2));
        } else {
            setTotalAmount((parseInt(ticketPrice) + parseInt(donation)) * 1.00);
        }

        eventData.transaction.totalAmount = totalAmount;
        console.log("Run 1 calculate price :", (eventData.events), ticketPrice, totalAmount);

    }, [noOfPeople, donation, feeEnabled, parivarEnabled, tempData.membershipType, ticketPrice, eventData.events, memberships.totalAmountPaid, memberships.status, parivarMember]);


        
          const eventTxnsHistoryFetch = async () => {
          let response, data;
          try {    
            const response = await fetch(`${API_URL}/gquery`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'x-cmdfw-jwt-token': `${accessToken}`,
              },
                body: JSON.stringify({
                    query: `
                            query {
                              eventsHistory {
                                  events {
                                      memEventsId
                                      status
                                      startDate
                                      endDate
                                      memberEntity {
                                          memberId
                                          memberType
                                          fullName
                                      }
                                      eventTypesEntity {
                                          eventTypeId
                                          name
                                          eventYear
                                      }
                                      transactionEntity {
                                          transactionId
                                          totalAmount
                                          paymentStatus
                                          createdAt
                                      }
                                  }
                                }
                            }
                          `,
              }),
            });
      
            const data = await response.json();
            if (response.ok) {
              console.log("Event history data API call:", response, data.data.eventsHistory.events);
    
              setEventTxnsHistory(data.data.eventsHistory.events);
            } else {
              if (response.status === 403) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'OTP expired');
                //handleLogout(); // Logout user
              } else {
                if (!response.ok) {
                  const errorData = await response.json();
                  throw new Error(errorData.message || 'Membership fetch failed');
                }
              }
            }
          } catch (error) {
            console.error("Error fetching Event Txns History :", error);
            //signOut();
            //navigate('/');
          }
        };

    const getRegisteredEventTypeIdForMember = (memberId) => {
        const registered = eventTxnsHistory
            ? eventTxnsHistory.find(
                txn =>
                    txn.status === "ACTIVE" &&
                    txn.memberEntity.memberId === memberId 
                    && culturalEventTypes.some(et => String(et.eventTypeId) === String(txn.eventTypesEntity.eventTypeId))
                    && !txn.eventTypesEntity.name.toLowerCase().includes('self study')
                        )
            : null;
        console.log("Registered Event Type ID for Member:", memberId, registered);
        return registered ? parseInt(registered.eventTypesEntity.eventTypeId, 10) : '';
    };


    // Filter cultural events to find self-study events
    const selfStudyEvents = culturalEventTypes.filter(
        eventType => eventType.name.toLowerCase().includes('self study')
    );
    const [selfStudySelections, setSelfStudySelections] = useState({});
    const [selfStudyChecked, setSelfStudyChecked] = useState({});
    const handleSelfStudyChange = (memberId, eventTypeId, checked) => {
        setSelfStudyChecked(prev => ({
            ...prev,
            [memberId]: {
                ...(prev[memberId] || {}),
                [eventTypeId]: checked
            }
        }));
        setEventData((prev) => {
            let updatedEvents = [...prev.events];


            if (checked) {
                // Only add if not already present
                const exists = updatedEvents.some(
                    ev => ev.memberId === memberId && ev.eventTypeId === parseInt(eventTypeId, 10)
                );
                if (!exists) {
                    updatedEvents.push({ memberId, eventTypeId: parseInt(eventTypeId, 10) });
                }
            } else {
                // Remove if unchecked
                updatedEvents = updatedEvents.filter(
                    ev => !(ev.memberId === memberId && ev.eventTypeId === parseInt(eventTypeId, 10))
                );
            }

            return { ...prev, events: updatedEvents };
        });
    };
       
    // Function to get registered self-study event IDs for a member
    const getRegisteredSelfStudyEventIdsForMember = (memberId) => {
        if (!eventTxnsHistory) return [];
        return eventTxnsHistory
            .filter(
                txn =>
                    txn.status === "ACTIVE" &&
                    txn.memberEntity.memberId === memberId &&
                    txn.eventTypesEntity.name.toLowerCase().includes('self study')
            )
            .map(txn => parseInt(txn.eventTypesEntity.eventTypeId, 10));
    };

    const handleLogout = () => {
        signOut();
        navigate('/');
      };

    const memberProfileFetch = async () => {
        console.log("Token value B", accessToken);
        let response, data;
        try {    
          //const response = await fetch('https://membership.cmdfw.org/api/gquery', {
          const response = await fetch(`${API_URL}/gquery`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-cmdfw-jwt-token': `${accessToken}`,
            },
              body: JSON.stringify({
                  query: `
                          query {
                            memberships {
                                balaviharYear
                                balaviharPeriod
                                status
                                totalAmountPaid
                                membershipTypes {
                                    membershipTypeId
                                    name
                                    startDate
                                    endDate
                                    bvPrice
                                    childQuantities
                                }
                                availableSessions {
                                    sessionId
                                    center
                                    sessionName
                                    grades {
                                        gradeId
                                        grade
                                    }
                                }
                                registeredSessions{
                                    bvRegistrationId
                                    regStartDate
                                    regEndDate
                                    status
                                    memberEntity{
                                        firstName
                                        lastName
                                        fullName
                                    }
                                    sessionEntity {
                                        sessionId
                                        center
                                        sessionName
                                    }
                                    gradeEntity{
                                        gradeId
                                        grade
                                    }
                                }
                                currentMembership {
                                    membershipId
                                    startDate
                                    endDate
                                    status
                                    notes
                                    bvYear
                                    createdAt 
                                    createdBy 
                                    membershipTypesEntity{
                                        membershipTypeId
                                        name
                                        startDate
                                        endDate
                                    }
                                    transactionEntity {
                                        transactionId
                                        eventTypesEntity {
                                            eventTypeId
                                            name
                                            eventYear
                                        }
                                        totalAmount
                                        paymentStatus
                                        createdAt 
                                        createdBy 
                                    }
                                }
                            }
                          }
                        `,
            }),
          });
    
          const data = await response.json();
          if (response.ok) {
            setMemberships(data.data.memberships);
            console.log("Membership data after API call:", data, response);
          } else {
            if (response.status === 403) {
              const errorData = await response.json();
              handleLogout(); // Logout user
              throw new Error(errorData.message || 'OTP expired');
            } else {
              if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Membership fetch failed');
              }
            }
          }
        } catch (error) {
          console.error("Error fetching Membership Profile :", error);
          signOut();
          //navigate('/');
        }
      };
    function loadMembershipFeeData() {
        //console.log("Membership Profile data to load fees  :", memberships);            

        memberships.membershipTypes.forEach((membershipType) => {
            if (membershipType.name === 'Chinmaya Parivar Member') {
                setTempData((prevData) => ({ ...prevData, membershipParivarMemberFee: membershipType.bvPrice }));
            } else if (membershipType.name === 'General Member (NO Balavihar)') {
                setTempData((prevData) => ({ ...prevData, membershipGeneralAdmissionFee: membershipType.bvPrice }));
            } else if (membershipType.name === 'Balavihar (Single Child)') {
                setTempData((prevData) => ({ ...prevData, membershipSingleChildFee: membershipType.bvPrice }));
            } else if (membershipType.name === 'Balavihar (2+ Children)') {
                setTempData((prevData) => ({ ...prevData, membershipTwoPlusChildFee: membershipType.bvPrice }));
            } else if (membershipType.name === 'Chinmaya Parivar (NO Balavihar)') {
                setTempData((prevData) => ({ ...prevData, membershipParivarNoBalaviharFee: membershipType.bvPrice }));
            }
        });
        

    };
    const checkoutHandler = (e) => {
        e.preventDefault();
        setError(null);
        // Skip payment if total amount is zero
        if (totalAmount >0 ) {        
            eventData.status = "pending";
        } else {
            eventData.status = "paid";
            setSuccess(true); // Skip payment if total amount is zero
        }
        setPayloadData(eventData); 

        //    console.log("transaction before sent to SQS:", (inputFields));
        if (sendToServer()) {
            console.log("checkout true");
            //setCheckout(true);
        } else {
            //setCheckout(false);
            console.log("checkout false");
        }
    };
    async function sendToServer() {
        const maxRetries = 3; // Maximum number of retries
        let attempt = 0;
        let url_link = `${API_URL}/events`;
        console.log("transaction before sent to Database:", eventData, url_link);


        while (attempt < maxRetries) {
            try {
            //const response = await fetch(`${API_URL}/events`, {
            const response = await fetch(url_link, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "x-cmdfw-jwt-token": `${accessToken}`,
                },
                body: JSON.stringify(eventData),
            });
            console.log('API response:', response.data);
            if (response.ok) {
                setCheckout(true);
                return true; // Success
            }
            if (response.status === 403) {
                const errorData = await response.json();
                handleLogout(); // Logout user
                throw new Error(errorData.message || 'OTP expired');
              } else {
                const errorData = await response.json();
                console.error('API Error:', errorData);
                setError(errorData.message);
                return false; // API call failed
                //throw new Error(errorData.message || 'API call failed');
            }
        } catch (error) {
            console.error(`Attempt ${attempt + 1} failed:`, error);
            attempt++;

            if (attempt >= maxRetries) {
                console.error('All retry attempts failed.');
                setCheckout(false);
                setError("Failed to send data to the server. Please try again later.");
                return false; // Return false after all retries fail
            }

            console.log(`Retrying API call... (${attempt}/${maxRetries})`);
 
        }
    }
    }


    function feeSwitchHandler(e) {
        setFeeEnabled(e.target.checked);
        eventData.feeEnabled = e.target.checked ;
        //console.log("Event data feeSwitchHandler :", (eventData.feeEnabled));
    }
    function parivarSwitchHandler(e) {
        setParivarEnabled(e.target.checked);
        eventData.parivarEnabled = e.target.checked ;
        if (e.target.checked) {
            setTicketPrice(tempData.membershipParivarMemberFee - memberships.totalAmountPaid);
            eventData.membershipType.name = "Chinmaya Parivar Member"; // Set membership type to "Chinmaya Parivar Member"
        } else {
            eventData.membershipType.name = ""; // Reset membership type if unchecked
        }
    }

    function handleBack() {
        setCheckout(false);
    }

    function handleDonation(e) {
        setInputFields({ ...inputFields, [e.target.name]: parseInt(e.target.value) });
        if (e.target.value >= 0) {
            setDonation(parseInt(e.target.value));
        }
    };

    const handleCancel = () => {
        navigate('/EventTypesForm');
        // Add any additional save logic here, such as API calls
      };
    
 
    const [success, setSuccess] = useState(false)
    const [checkout, setCheckout] = useState(false)


    return (
        <div>
            <Grid item xs={12} sm={12}>
                    <Typography variant="h6" align="center" gutterBottom>
                        {'CMDFW Registration System'}
                    </Typography>
                </Grid>

            <form onSubmit={checkoutHandler}>
                <Grid container direction="column" alignItems="center" >
                    {
                        checkout ?
                            success  ?
                                <Grid item>
                                    <img src={successIcon} className="Success-icon" alt="logo" />
                                    <Typography variant="h5" align="center" gutterBottom>
                                        {'Thank You for the Registration'}
                                    </Typography>
                                    <Box sx={{ width: '100%', maxWidth: 500 }}>
                                        <Typography variant="body2" align="left" gutterBottom>
                                            You will receive an email confirmation to this address <b> [ {email} ] </b>
                                        </Typography>
                                    </Box>
                                </Grid>
                                :
                                
                                <Grid item>
                                    <PaypalComp eventData={eventData} setSuccess={setSuccess} payloadData={payloadData}/>
                                    <span>
                                        <Button type="submit" variant="contained" sx={{ mt: 3, mb: 2 }} onClick={() => handleBack()}>Back</Button>
                                    </span>
                                </Grid>
                            :
                            <div>
                                <Grid item xs={12} sm={12}>
                                <Paper elevation={3}>
                                <Paper style={{ padding: '16px', backgroundColor: '#dfe7e7', color: 'black' }} elevation={3}>
                                    <Grid item>
                                        <Box sx={{ width: '100%', minWidth: 300 }}>
                                            <Typography variant="body2" align="left" gutterBottom>

                                                <div><b>Event:</b> {languageEventType.name}</div>
                                                 <div>{parse(languageEventType.desc || "")}</div><br />
                                                <div><br /></div>
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    </Paper>
                                    </Paper>
                                </Grid>
                                <div><br /></div>
                                <Grid item xs={12} sm={12}>
                                {
                                    memberships.status === "ACTIVE" ?
                                        (
                                        <div>
                                        <div>Membership status is <b>Active</b> for the period: <b>{memberships.balaviharPeriod}</b></div>
                                        <div>Membership Type : <b>{memberships.currentMembership.membershipTypesEntity.name}</b></div>
                                        <div><br /></div>
                                        </div>
                                        )

                                        :
                                        
                                        (
                                        <div><b>Membership expired.</b> 
                                        <div><b>RENEW</b> the membership for the period: <b>{memberships.balaviharPeriod}</b></div>
                                                    <div><br /></div>
                                                    <Grid item xs={12} sm={12}>
                                                        <Paper elevation={3}>
                                                            <Paper style={{ padding: '16px', backgroundColor: '#dfe7e7', color: 'black' }} elevation={3}>
                                                                <Grid item>
                                                                    <Box sx={{ width: '100%', minWidth: 300 }}>
                                                                        <Typography variant="body2" align="left" gutterBottom>

                                                                            <div><b>Your Membership has expired. Please RENEW your membership before registering for Language/Cultural classes. </b></div>
                                                                            
                                                                        </Typography>
                                                                    </Box>
                                                                </Grid>
                                                            </Paper>
                                                        </Paper>
                                                    </Grid>
                                                    <Grid item>
                                                        <Button onClick={handleCancel} variant="contained" sx={{ mt: 3, mb: 2 }}>Cancel</Button>
                                                    </Grid>
                                                    <Grid item>
                                                        <Typography variant="body2" align="center" gutterBottom>
                                                            If you have any questions, please contact us at <a href="mailto:membership@cmdfw.org">membership@cmdfw.org</a>
                                                        </Typography>
                                                    </Grid>

                                                </div>
                                                
                                        )
                                        }                           
                                    
                                
                                </Grid>
                                

                                <Grid item xs={12} sm={12}>
                                {
                                tempData.membershipType === "Balavihar" || memberships.status === "ACTIVE" ? 
                                    <Grid container alignItems="center" >
                                        
                                    <Paper elevation={3}>
                                        <Paper style={{ padding: '16px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>
                                        <Typography variant="h7" align="left" gutterBottom>
                                            <b>Cultural/Language Class Registration</b>
                                        </Typography>
                                        </Paper>
                                        <div><br /></div>
                                         

                                        <Grid container spacing={2}>
                                            {fullNames.map((child, fullNameIndex) => {
                                                
                                                const registeredEventTypeId = getRegisteredEventTypeIdForMember(child.memberId);
                                                const registeredSelfStudyIds = getRegisteredSelfStudyEventIdsForMember(child.memberId);

                                                // If already registered, use that as the selected value and disable the group
                                                const selectedEventTypeId = registeredEventTypeId ||
                                                    (eventData.events.find(ev => ev.memberId === child.memberId)?.eventTypeId || '');

                                                const isRegistered = Boolean(registeredEventTypeId);
                                                const selectedMainEventType = culturalEventTypes.find(
                                                    et => et.eventTypeId === parseInt(selectedEventTypeId, 10)
                                                );
                                                let filteredSelfStudyEvents = [];
                                                if (selectedMainEventType) {
                                                    if (selectedMainEventType.name === 'Shlokathon') {
                                                        filteredSelfStudyEvents = culturalEventTypes.filter(
                                                            et => et.name === 'Gita Chanting-Self Study'
                                                        );
                                                    } else if (selectedMainEventType.name === 'Gita Chanting') {
                                                        filteredSelfStudyEvents = culturalEventTypes.filter(
                                                            et => et.name === 'Shlokathon-Self Study'
                                                        );
                                                    } else {
                                                        filteredSelfStudyEvents = culturalEventTypes.filter(
                                                            et => et.name === 'Gita Chanting-Self Study' || et.name === 'Shlokathon-Self Study'
                                                        );
                                                    }
                                                }

                                                //console.log("Registered events for member1:", registeredEventIds, child, eventData.events, culturalEventTypes);
                                                return (
                                                    <Grid item xs={12} key={fullNameIndex}>
                                                        <Paper elevation={3} style={{ padding: '16px', backgroundColor: '#f9f9f9' }}>
                                                            <FormControl component="fieldset">
                                                                <FormLabel component="legend">{child.fullName}</FormLabel>
                                                                <RadioGroup
                                                                    //row
                                                                    name={`event-radio-group-${child.memberId}`}
                                                                    value={selectedEventTypeId}
                                                                      onChange={(e) => handleEventRadioChange(child.memberId, e.target.value)}
                                                                        disabled={isRegistered}
                                                                >
                                                                    {culturalEventTypes
                                                                        .filter(eventType => !eventType.name.toLowerCase().includes('self study')) // <-- Add this filter
                                                                        .map((eventType, eventTypeIndex) => (
                                                                        <FormControlLabel
                                                                            key={eventTypeIndex}
                                                                            value={eventType.eventTypeId}
                                                                            control={<Radio />}
                                                                            label={eventType.name}
                                                                            disabled={isRegistered}
                                                                        />
                                                                    ))}
                                                                </RadioGroup>
                                                                {/* Show self-study checkboxes only if a non-self-study event is selected */}
                                                                {selectedEventTypeId && !(isRegistered) && (

                                                                <Grid container direction="row" spacing={5}>
                                                                    <Grid item>
                                                                        <br />
                                                                        <Typography variant="body2" align="center" gutterBottom>
                                                                            <b>Please select the following Self Study Options if you are interested</b>
                                                                        </Typography>
                                                                    </Grid>
                                                                </Grid>
                                                                )}
                                                                    {filteredSelfStudyEvents.map((eventType) => (                                                                        
                                                                        <FormControlLabel
                                                                            key={eventType.eventTypeId}
                                                                            control={
                                                                                <Checkbox
                                                                                    checked={
                                                                                        (selfStudyChecked[child.memberId] && selfStudyChecked[child.memberId][eventType.eventTypeId]) ||
                                                                                        registeredSelfStudyIds.includes(parseInt(eventType.eventTypeId, 10))
                                                                                    }
                                                                                    onChange={e =>
                                                                                        handleSelfStudyChange(child.memberId, eventType.eventTypeId, e.target.checked)
                                                                                    }
                                                                                />
                                                                            }
                                                                            label={eventType.name}
                                                                        />
                                                                    ))}
                                                            </FormControl>
                                                        </Paper>
                                                    </Grid>
                                                );
                                            })}
                                        </Grid>    
                                            
                                        <div><br /></div>
                                        
                                        </Paper>
                                    </Grid>
                                    : "" }

                                </Grid>
                                                                                       
                                {
                                    memberships.status === "ACTIVE" ? (  
                                <Grid item xs={12} sm={12}>                  
                                <div><br /></div>
                                <Paper elevation={3}>
                                        <Paper style={{ padding: '16px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>
                                        <Typography variant="h7" align="left" gutterBottom>
                                            <b>Payment Information</b>
                                        </Typography>
                                </Paper>
                                <div><br /></div>
                                <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            disabled
                                            id="FeeAmountPaid"
                                            label="Balavihar Fee Paid Amount($)"
                                            type="number"
                                            name="feeAmountPaid"
                                            variant="standard"
                                            value={memberships.totalAmountPaid}
                                        />
                                    </Grid>

                                <Grid item xs={12} sm={12}>
                                        <FormGroup>
                                            <FormControlLabel control={<Checkbox checked={parivarEnabled} disabled={parivarMember} />} label={`${tempData.membershipParivarMemberFee} (Upgrade to Parivar membership - All events included with this fee)`}
                                                value={parivarEnabled} size="small" onChange={parivarSwitchHandler} />
                                        </FormGroup>
                                    </Grid>
                                <div><br /></div>
                                <Grid container direction="row" spacing={2} >
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            number
                                            id="donation"
                                            label="Additional Donation ($)"
                                            type="number"
                                            name="donation"
                                            variant="standard"
                                            value={donation}
                                            onChange={handleDonation}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FormGroup>
                                            <FormControlLabel control={<Checkbox checked={feeEnabled} />} label="Add 3% to cover for CC fees"
                                                value={feeEnabled} size="small" onChange={feeSwitchHandler} />
                                        </FormGroup>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <TextField
                                            fullWidth
                                            disabled
                                            id="totalAmountField"
                                            label="Total Amount($)"
                                            type="number"
                                            name="totalAmount"
                                            variant="standard"
                                            inputProps={{ style: { fontSize: 20 } }} // font size of input text
                                            InputLabelProps={{ style: { fontSize: 20 } }} // font size of input label
                                            value={totalAmount}
                                        />
                                    </Grid>
                                </Grid>
                                </Paper>

                                <div><br /></div>
                                <Grid container direction="row" spacing={5}>
                                    <Grid item>
                                        <Typography variant="body2" align="center" gutterBottom>
                                        <b>Waiver Statement (Please read and agree to the waiver statement before you proceed) :</b> <a href="https://membership.cmdfw.org/docs/cmdfw-waiver.pdf" target="_blank" rel="noopener noreferrer"> Open PDF </a>
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid container direction="row" spacing={5}>
                                    <Grid item>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={rulesAccepted}
                                                    onChange={(e) => setRulesAccepted(e.target.checked)}
                                                    name="rulesAccepted"
                                                    color="primary"
                                                />
                                            }
                                            label="I accept the rules and policies"
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container direction="row" spacing={2}>
                                    
                                    <Grid item>
                                        <Button onClick={handleCancel} variant="contained" sx={{ mt: 3, mb: 2 }}>Cancel</Button>
                                    </Grid>
                                    <Grid item>
                                    <Tooltip title={!rulesAccepted ? "Please accept the rules and policies" : ""}>
                                        <span>
                                        <Button type="submit" variant="contained" sx={{ mt: 3, mb: 2 }} disabled={!rulesAccepted}>Checkout</Button>
                                        </span>
                                    </Tooltip>
                                    </Grid>
                                    {error && (
                                        <Grid item xs={12}>
                                            <Alert severity="error">{error}</Alert>
                                        </Grid>
                                    )}
                                </Grid>
                                    <Grid container direction="row" spacing={5}>
                                    <Grid item>
                                        <Typography variant="body2" align="center" gutterBottom>
                                            If you have any questions, please contact us at <a href="mailto:membership@cmdfw.org">membership@cmdfw.org</a>
                                        </Typography>
                                    </Grid>
                                </Grid>
                                </Grid> ) : "" }
                            </div> 
                    }
                </Grid>
            </form>
        </div >
    );
}